var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PLazy extends Promise {
  constructor(_executor) {
    super((resolve) => resolve());
    this._executor = _executor;
    __publicField(this, "_promise");
    __publicField(this, "then", (onFulfilled, onRejected) => (this._promise || (this._promise = new Promise(this._executor))).then(onFulfilled, onRejected));
    __publicField(this, "catch", (onRejected) => (this._promise || (this._promise = new Promise(this._executor))).catch(onRejected));
    __publicField(this, "finally", (onFinally) => (this._promise || (this._promise = new Promise(this._executor))).finally(onFinally));
  }
}
function LazyPromise(fn) {
  return new PLazy((resolve, reject) => {
    try {
      Promise.resolve(fn()).then(resolve, reject);
    } catch (err) {
      reject(err);
    }
  });
}

export { LazyPromise, PLazy };
